module.exports = __webpack_public_path__ + "static/img/results.eaa44cc0.png";